import React, { FC } from 'react';
import Alert from '@material-ui/lab/Alert';
import { Typography } from '@material-ui/core';

export const Info: FC = () => {
    return (
        <>
            <Typography variant="h4" paragraph>
                Informacje o wyszukiwarce
            </Typography>
            <Typography variant="body1" paragraph>
                Wyszukiwarka substancji jest usługą pomocniczą ułatwiającą
                przyporządkowanie substancji emitowanej do powietrza do
                odpowiedniej pozycji na listach substancji w systemach:
            </Typography>
            <Typography variant="body1" component="ul" paragraph>
                <li>
                    <strong>
                        Krajowej bazy o emisjach gazów cieplarnianych i innych
                        substancji
                    </strong>{' '}
                    - zgodnie z Wykazem gazów cieplarnianych i innych substancji
                    wprowadzanych do powietrza objętych systemem zarządzania
                    emisjami gazów cieplarnianych i innych substancji,
                    stanowiącym załącznika nr 1 do ustawy z dnia 17 lipca 2009
                    r. o systemie zarządzania emisjami gazów cieplarnianych i
                    innych substancji
                </li>
                <li>
                    <strong>
                        Opłat za korzystanie ze środowiska, o których mowa w
                        art. 273 ust. 1 pkt 1 ustawy z dnia 27 kwietnia 2001 r.{' '}
                        <em>Prawo ochrony środowiska</em>{' '}
                    </strong>
                    - zgodnie z tabelą A załącznika nr 1 do rozporządzenia Rady
                    Ministrów z dnia 22 grudnia 2017 r. w sprawie jednostkowych
                    stawek opłat za korzystanie ze środowiska 
                </li>
            </Typography>
            <Typography variant="body1" paragraph component="div">
                <Alert severity="warning">
                    Zaproponowana kwalifikacja gazów oraz pyłów do właściwych
                    grup ma charakter pomocniczy i nie stanowi wiążącej
                    interpretacji prawa. KOBiZE IOŚ-PIB nie jest jednostką
                    właściwą do rozstrzygania kwestii przyporządkowania
                    zanieczyszczeń wprowadzanych do powietrza do sytemu opłat za
                    korzystanie ze środowiska, kompetencje te leżą w gestii
                    marszałka województwa.
                </Alert>
            </Typography>
        </>
    );
};
